<template>
    <div class="notes-drawer">
        <div class="notes-tray-header">
            <img class="notes-icon" src="../assets/icons/notes_selected.svg">
            <div class="notes-title">{{$t('str.Notes')}}</div>
            <div class="notes-buttons"> 
                <transition-group name="wave">  
                    <span :key="1" v-show="isDirty === false" class="autosaving" contenteditable="false">s</span>
                    <span :key="2" v-show="isDirty === false" class="autosaving" contenteditable="false">a</span>
                    <span :key="3" v-show="isDirty === false" class="autosaving" contenteditable="false">v</span>
                    <span :key="4" v-show="isDirty === false" class="autosaving" contenteditable="false">e</span>
                    <span :key="5" v-show="isDirty === false" class="autosaving" contenteditable="false">d</span>
                </transition-group>             
                <!--a class="btn" v-on:click="downloadNotes">
                    <i class="fa fa-download"></i>
                </a-->
                <a class="btn" v-on:click="emailNotes" :title="$t('str.emailNotes')">
                    <i class="fa fa-envelope"></i>
                </a>
                <a class="btn" v-on:click="copyToClipboard" :title="$t('str.copyToClipboard')">
                    <i class="fa fa-clipboard"></i>
                </a>
                <a v-on:click="close" class="notes-btn-right" :title="$t('str.Close')">
                    <i class="fa fa-times"></i>
                </a>
            </div>
        </div>
        <div class="notes-body">
            <textarea name="user-notes" class="note-content" :placeholder="$t('str.MyPrivateNote')" v-model="userNotes"></textarea>
            <div class="notes-arrow"></div> 
        </div>
    </div>
</template>

<script>

import StorageUtils from '../javascript-classes/utils/storage.js';
import Notes from '../javascript-classes/Notes';
import {LeadBus} from '../router/index';

const AUTO_SAVE_TIMER = 5000;
const CLEAR_SAVED_LABEL_TIMER = 6000;

export default {
    props: {
        presentation: {},
        user: {},
        slideList: {},
        currentSlide: ''
    },

    data () {
        return {
            currentSlideId: '',
            notes: undefined,
            userNotes_: undefined, // Cached version of user notes for the userNotes computed property only.
            autosaveTimer: undefined,
            isDirty: undefined
        };
    },

    computed: {
        userNotes: {
            get() {
                if (!this.slideList || !this.user) {
                    return "";
                }

                if (this.userNotes_ !== undefined) {
                    return this.userNotes_;
                }

                this.currentSlideId = this.slideList[this.currentSlide].slideId;
                this.userNotes_ = "";

                // load from localStorage
                let str = StorageUtils.getItem(this.user.id);

                if (str === undefined || str === null) {
                    return;
                }

                let notesJson;

                try {
                    notesJson = JSON.parse(str);
                } catch(e) {
                    console.log(e)
                    return;
                }

                if (!notesJson) {
                    return;
                }

                this.notes = new Notes(this.user.id, notesJson.content);
                this.userNotes_ = this.notes.get(this.presentation.id, this.currentSlideId, "");

                return this.userNotes_;
            },

            set(notes) {
                this.userNotes_ = notes;
                this.isDirty = true;
            }
        }
    },

    beforeDestroy() {
        if (this.autosaveTimer) {
            clearTimeout(this.autosaveTimer);
        }

        this.save();
    },

    mounted () {
        if (this.slideList && this.currentSlide && this.slideList[this.currentSlide]) {
            this.currentSlideId = this.slideList[this.currentSlide].slideId;
        }

        this.scheduleNextAutoSaving();
    },

    watch: {
        currentSlide() {
            this.save();
            this.userNotes_ = undefined;
        }
    },

    methods: {
        close() {
            this.$emit('closeTray');
        },

        downloadNotes() {
            LeadBus.$emit('recordLead', {
                type: 'notes-download-pfd',
                data: {}
            });
        },

        emailNotes() {
            if (this.presentation === null || !this.user) {
                return;
            }

            this.save();

            let sNotesToEmail = "";
            let oTemp = {
                title: this.presentation.title,
                sessionId: this.presentation.id,
                notesMetrics: {}
            };
            let index = 1;

            this.notes.list(this.presentation.id).map((noteSlide) => {
                if (noteSlide.text === "") {
                    return;
                }

                oTemp.notesMetrics[index] = noteSlide.text.length;
                sNotesToEmail += this.$t('str.SlideOf', {
                    slideIndex: index,
                    savedNote: noteSlide.text
                });
                sNotesToEmail += "\r\n\r\n";

                ++index;
            });

            let sSubject = this.$t('str.EmailNotesSubject', {
                firstname: this.user.firstname,
                presentation: this.presentation.title
            });
            let windowForEmailLaunch = window.open(`mailto:?subject=${encodeURI(sSubject)}&body=${encodeURIComponent(sNotesToEmail)}`);

            if (windowForEmailLaunch !== null) {
                setTimeout(() => windowForEmailLaunch.close(), 1000);
            }

            LeadBus.$emit('recordLead', {
                type: 'notes-launched-email',
                data: oTemp
            });
        },

        copyToClipboard() {
            let el = this.$el.querySelector('[name="user-notes"]');

            el.select();
            document.execCommand('copy');
            LeadBus.$emit('recordLead', {
                type: 'notes-copied-to-clipboard',
                data: {
                    currentNote: this.currentNote,
                    currentSlide: this.currentSlideId
                }
            });

            // Unselect text
            let sel;

            if ((sel = document.selection) && sel.empty) {
                sel.empty();
            } else {
                if (window.getSelection) {
                    window.getSelection().removeAllRanges();
                }
            
                // Collapse the selection to the end
                el.selectionStart = el.selectionEnd;
            }
        },

        scheduleNextAutoSaving() {
            if (this.autosaveTimer) {
                clearTimeout(this.autosaveTimer);
            }

            this.autosaveTimer = setTimeout(() => {
                this.autosaveTimer = undefined;
                this.save();
                this.scheduleNextAutoSaving();
            }, AUTO_SAVE_TIMER);
        },

        save() {
            if (!this.isDirty || !this.slideList || !this.currentSlideId) {
                return;
            }

            if (!this.notes) {
                this.notes = new Notes(this.user.id);
            }

            this.notes.update(this.presentation.id, this.currentSlideId, this.userNotes);

            if (StorageUtils.setItem(this.user.id, this.notes) === false) {
                alert(this.$t('str.UnableToSaveNotesToLocalStorageEnsureYouAreNotInIncognitoMode'));
                return;
            }

            this.isDirty = false;

            // Set to undefined after timeout so that we can remove the "saved" label from UI.
            setTimeout(() => this.isDirty = undefined, CLEAR_SAVED_LABEL_TIMER);
        }
    }
};

</script>

<style lang="scss">

.notes-drawer {
    height: 50vh;
    color: #fff;
    z-index: 4000;
    position: absolute;
    width: 100%;
    bottom: 0;
    overflow: hidden;
    background-color: #000000;

    .notes-tray-header {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: calc(100% - 20px);
        height: 45px;
        background-color: #333;
        margin-top: 5px;

        .notes-title {
            cursor: default;
            padding-top: 13px;
            display: inline-block;
            vertical-align: middle;
            font-weight: 500;
            font-size: 1em;
            font-family: 'Poppins', sans-serif;
            user-select: none;
        }

        .notes-icon {
            width: 35px;
            user-select: none;
            vertical-align: middle;
            padding-left: 15px;
            padding-right: 10px;
            padding-top: 10px;
        }

        .notes-buttons {
            float: right;
            padding-right: 15px;
            vertical-align: middle !important;
            padding-top: 10px;

            .autosaving {
                cursor: default;
                font-size: 1em;
                font-family: 'Poppins', sans-serif;
                vertical-align: middle !important;
                color: green;
                user-select: none;
                display: inline-block;
                animation: wave 1.3s linear;             
            }

            span.autosaving:last-child {
                padding-right: 15px;
            }

            .wave-enter-active {
                &:nth-child(1) {
                    animation-delay: 0.5s;
                }
                &:nth-child(2) {
                    animation-delay: 0.7s;
                }

                &:nth-child(3) {
                    animation-delay: 0.9s;
                }

                &:nth-child(4) {
                    animation-delay: 1.1s;
                }

                &:nth-child(5) {
                    animation-delay: 1.3s;
                }
            }
        }

        .btn {
            width: 20px;
            height: 20px;
            cursor: pointer;
            padding-right: 15px;
            vertical-align: middle !important;
        }

        .notes-btn-right {
            font-size: 20px;
            vertical-align: middle !important;
            background: transparent;
            color: #fff;
            cursor: pointer;
        }
    }
    .notes-body {
        font-family: 'Poppins', sans-serif;
        height: calc(100% - 120px);
        position: relative;
        z-index: 999;

        .note-content {
            display: block;
            margin-left: auto;
            margin-right: auto;
            height: calc(100% - 10px);
            width: calc(100% - 50px);
            padding: 15px;
            font-weight: 300;
            background-color: #fff;
            line-height: 1.4;
            font-size: 1em;
            outline: none;
            resize: none;
            font-family: "Poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;
            font-weight: normal;
            color: #000;
            overflow: auto;
            margin-top: 5px;
        }
    }

    .notes-arrow {
        position: fixed;
        display: block;
        border: solid transparent;
        border-right-color: #000;
        content: '';
        height: 0;
        width: 0;
        right: calc(10% - 15px);
        bottom: 55px;
        border-width: 15px;
        transform: rotate(90deg);
    }
}

@keyframes wave {
    0% {
		transform: initial;
	}
    30% {
		transform: translateY(-8px);
	}
    60% {
		transform: initial;
	}
    100% {
		transform: initial;
	}
}

</style>



// WEBPACK FOOTER //
// NotesTray.vue?5f3ea1bb